// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import software from './metaData/software'
export default {
  state: software,
  actions
}
